module.exports = __webpack_public_path__ + "img/nana.b474ec4c.jpeg";